import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { confirmationHeaders } from '../../../common/utils/warningMessage';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';

const commitInputDataDrafts = async ({
  confirmWarnings,
  ...params
}: {
  sessionId: string;
  confirmWarnings?: boolean;
}) =>
  apiClient
    .post(expand(InputDataEditSessionUrl.commit, params), undefined, {
      headers: confirmationHeaders(confirmWarnings),
    })
    .then((response) => response.data);

export const useCommitInputDataDraftsMutation = createApiMutationHook(
  ['input-data-drafts-commit'],
  commitInputDataDrafts,
);
